/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class subscriberreference extends IceEntity {
  subscriber_reference_key: string = "";
  subscriber_key: string = "";
  coverage_key: string = "";
  payer_key: string = "";
  payer_responsibility_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "SUBSCRIBER_REFERENCE";
  }
}
